<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link
              v-if="$route.meta.rtlActive"
              :to="{ path: 'https://www.creative-tim.com' }"
              >منزل</router-link
            >
            <a v-else href="https://www.creative-tim.com">We-Build.City</a>
          </li>
          <li>
            <a v-if="$route.meta.rtlActive" href="http://blog.creative-tim.com">
              شركة
            </a>
            <a v-else href="https://creative-tim.com/presentation">
              Über uns
            </a>
          </li>
          <li>
            <a v-if="$route.meta.rtlActive" href="http://blog.creative-tim.com">
              محفظة
            </a>
            <a v-else href="http://blog.creative-tim.com">
              Informationen
            </a>
          </li>
          <li>
            <a v-if="$route.meta.rtlActive" href="/"> </a>
            <a v-else href="">
              Aktuelles
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://we-build.city" target="_blank"> We-Build.City Team</a
        >,entwickelt aus <i class="fa fa-heart heart"></i> eine bessere Welt.
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
